import { useTranslation } from 'react-i18next';
import React ,{ createContext} from "react" //createContext 是创建一个上下文对象
export const orderContext = createContext({}) // 创建了一个上下文对象
export const {Provider,Consumer} = orderContext